import lessRequire from '../../../../config/less-require-resolver';
import PropTypes from 'prop-types';
import React from 'react';
import cn from 'classname';

import capitalize from 'lodash/capitalize';
import find from 'lodash/find';

import ImagePlaceholdered from '../../../shared/image-placeholdered';
import { mapTableSortHeaders, showMoreRows } from '../../../shared/table-helpers';
import OfferPromoLabels from '../../../shared/offer-promo-labels';

lessRequire('modules/offers/components/table/landings-transits.less');

const propTypes = {
	data: PropTypes.array,
	langList: PropTypes.array,
	type: PropTypes.string,
	tableHeaders: PropTypes.array,
	sortByColumn: PropTypes.func,
	columnSorting: PropTypes.object,
	isCanNotMoveToNext: PropTypes.bool,
	canSeeTransits: PropTypes.bool,
	showMore: PropTypes.func,
	intl: PropTypes.func
};

const LandingsTransitsTable = ({
	data,
	langList,
	type,
	tableHeaders,
	sortByColumn,
	columnSorting,
	isCanNotMoveToNext,
	canSeeTransits,
	showMore,
	intl
}) =>
	<table className="dashboard-table single-offer__land-trans-table">
		<thead className="dashboard-table__head font-proxima-nova-semibold">
			<tr>
				{mapTableSortHeaders({
					headers: swapPreviewText(tableHeaders, type),
					columnSorting,
					sortByColumn,
					intl
				}).map((header, i) => <th key={i} className={i >= 2 ? 'data-value' : ''}>{header}</th>)}
			</tr>
		</thead>

		<tbody className="dashboard-table__body">
			{data.map(row =>
				<tr key={row.id}>
					<td className="preview">
						<ImagePlaceholdered
							src={type === 'landings' || canSeeTransits ? row.image : null}
							alt={type === 'landings' ? intl('Превью лэндинга') : intl('Превью транзитки')}
							className="preview__landing"
						/>
					</td>
					<td className={cn({
						'title': true,
						'has-labels': !!row.labels.length,
						'blurry': !(type === 'landings' || canSeeTransits)
					})}>
						<OfferPromoLabels intl={intl} labels={row.labels} />
						{type === 'landings' || canSeeTransits
							? <a href={`http://${row.domain}`} target="_blank" className="font-proxima-nova-semibold">{row.title}</a>
							: row.title
						}
					</td>
					<td className="languages">
						{ row.languages.map((lang, i) => (
							<span key={i} className='lang'>{ getLang(langList, lang) }</span>
						)) }
					</td>
					<td className="data-value">
						{parseFloat(row.cr) > 0 && <span>{parseFloat(row.cr.toFixed(2))} <i className="currency">%</i></span>}
						{(!row.cr || parseFloat(row.cr) <= 0) && <span>{intl('NEW!')}</span>}
					</td>
				</tr>
			)}
			{!isCanNotMoveToNext && data.length && showMore ? showMoreRows(showMore, `${capitalize(type)}Table`, intl) : null}
		</tbody>
	</table>;

LandingsTransitsTable.propTypes = propTypes;
export default LandingsTransitsTable;

const swapPreviewText = (headers, type) => {
	return headers.map((header, i) => {
		if (i === 0) {
			if (type === 'landings') {
				return { ...header, title: 'Лендинг' };
			} else if (type === 'transits') {
				return { ...header, title: 'Транзитка' };
			} else {
				return header;
			}
		} else {
			return header;
		}
	});
};

const getLang = (langList, lang) => {
	const langInList = find(langList, {id: lang});
	return langInList ? langInList.text : lang;
};



// WEBPACK FOOTER //
// ./frontend/cabinets/modules/offers/components/table/landings-transits.js